// reducers/index.ts  （或你原来的文件名）
// Vite + TypeScript 写法：用 import.meta.glob 收集同目录下的 .ts（非递归）
//
// 约定：每个 reducer 文件：
//   export const REDUCER_NAME = 'xxx'
//   export default yourReducer
//
// 如果你有些 slice 导出了 slice 对象，也支持用 slice.name 作为兜底。

import type { Reducer, ReducersMapObject } from '@reduxjs/toolkit';

type ReducerModule = {
    default: Reducer;
    REDUCER_NAME?: string;
    // 可选兜底：如果模块导出了 slice（createSlice），用 slice.name 作为 key
    slice?: { name: string };
};

// 同目录下所有 .ts（包含 index.ts，本例里我们会过滤掉）
const modules = import.meta.glob<ReducerModule>('./*.ts', {
    eager: true, // 同步加载，跟原来的 require.context 行为一致
}) as Record<string, ReducerModule>;

export default function collectReducers(): ReducersMapObject {
    const reducers: ReducersMapObject = {};

    for (const [path, mod] of Object.entries(modules)) {
        // 过滤自身与声明文件
        if (/\/index\.ts$/.test(path) || /\.d\.ts$/.test(path)) continue;

        const name = mod.REDUCER_NAME ?? mod.slice?.name; // 兜底：如果模块导出了 slice，可用 slice.name

        const reducer = mod.default;

        if (name && reducer) {
            reducers[name] = reducer;
        } else if (import.meta.env?.DEV) {
            console.warn(`[reducers] skip ${path}: missing REDUCER_NAME/default`);
        }
    }

    return reducers;
}
